import { render, staticRenderFns } from "./SearchCriterion.vue?vue&type=template&id=2f2a1a4b&scoped=true&"
import script from "./SearchCriterion.vue?vue&type=script&lang=js&"
export * from "./SearchCriterion.vue?vue&type=script&lang=js&"
import style0 from "./SearchCriterion.vue?vue&type=style&index=0&id=2f2a1a4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2a1a4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VTextField,
})
